import React from 'react';

import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import { faChevronRight, faPlus } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useDialogs } from '../../../hooks';
import { taskStatusShape } from '../../../types';

const HEADER_STYLES =
  'flex items-center justify-between border-b bg-muted px-2 py-1 sticky top-0 z-10';

const Header = ({ isCollapsed, onToggle, status, taskCount }) => {
  const { handleNewTaskClick } = useDialogs();

  return (
    <div className={HEADER_STYLES}>
      <div className="flex items-center gap-2">
        <Button
          aria-expanded={!isCollapsed}
          aria-label={`Toggle ${status.name}`}
          className="text-muted-foreground hover:text-foreground"
          onClick={onToggle}
          size="icon"
          variant="ghost"
        >
          <FontAwesomeIcon
            className={cn('transition-transform', !isCollapsed && 'rotate-90')}
            icon={faChevronRight}
            size="xs"
          />
        </Button>

        <span className="font-medium text-foreground">{capitalize(status.name)}</span>
        <span className="text-muted-foreground">{taskCount}</span>
      </div>

      <Button
        className="text-muted-foreground hover:text-foreground"
        onClick={handleNewTaskClick}
        variant="ghost"
      >
        <FontAwesomeIcon icon={faPlus} size="xs" />
      </Button>
    </div>
  );
};

Header.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  status: taskStatusShape.isRequired,
  taskCount: PropTypes.number.isRequired,
};

export default Header;
